import * as types from 'models/actionTypes'

export const saveSelectedCompositionToLocalStorage = () => ({
    type: types.SAVE_SELECTED_COMPOSITION_TO_LOCAL_STORAGE,
})

export const loadCompositionFromLocalStorage = () => ({
    type: types.LOAD_COMPOSITION_FROM_LOCAL_STORAGE,
    composition: null, // Filled in middleware
})
